import { render, staticRenderFns } from "./MailTemplateList.vue?vue&type=template&id=15fc0ad4&"
import script from "./MailTemplateList.vue?vue&type=script&lang=js&"
export * from "./MailTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateList.vue?vue&type=style&index=0&id=15fc0ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports